import BaseService from "@services/BaseService";

export default class RuleService extends BaseService {
  entity = "rules";
}
